import React from 'react'
import { TwoColumnWithProminence, SingleColumn } from '@ycos/component-columns'
import Block from '@ycos/component-block'
import Markdown from '@ycos/markdown'

const HeadlineWithCopy = ({ item, isGreySection, onMarkdownTargetClick }) => {
  const { teaserText, teaserTitle } = item
  const size = isGreySection ? 'medium' : 'large'
  const layoutVariant = {
    small: 'isc-block-with-small-title',
    medium: 'isc-block-with-medium-title',
    large: 'isc-block-with-large-title'
  }[size || 'large']

  if (teaserText) {
    return (
      <TwoColumnWithProminence desktopReverse prominence="right">
        <Block item={{ layoutVariant, teaserTitle }} />
        <Markdown teaserText={teaserText} onMarkdownTargetClick={onMarkdownTargetClick} />
      </TwoColumnWithProminence>
    )
  }
  return (
    <SingleColumn item={{ layoutVariant: 'isc-single-column-left-prominence' }}>
      <Block item={{ layoutVariant, teaserTitle }} />
    </SingleColumn>
  )
}

HeadlineWithCopy.layoutVariant = 'isc-headline-copy'

export default HeadlineWithCopy
